import type { IUser } from './user/types';
import type { DialogKeys } from './ui/types';
import type { AppActionTypes } from './app/action-types';
import type { ISubscription } from './subscription/types';
import type { CelloActionTypes } from './cello/action-types';
import type { WorkspaceActionTypes } from './workspace/action-types';
import type { H5PEditorActionTypes } from './h5p-editor/action-types';
import type { ContentBrowserActionTypes } from './content-browser/action-types';

export * from './app/action-types';
export * from './cello/action-types';
export * from './workspace/action-types';
export * from './h5p-editor/action-types';
export * from './content-browser/action-types';

// constants
export const AUTH_LOGIN_REQUEST = 'AUTH_LOGIN_REQUEST';
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';
export const AUTH_LOGOUT_REQUEST = 'AUTH_LOGOUT_REQUEST';
export const AUTH_GETSESSION_REQUEST = 'AUTH_GETSESSION_REQUEST';
export const AUTH_GETSESSION_SUCCESS = 'AUTH_GETSESSION_SUCCESS';
export const AUTH_GETSESSION_FAILURE = 'AUTH_GETSESSION_FAILURE';
export const AUTH_REGISTER_REQUEST = 'AUTH_REGISTER_REQUEST';

export const SUBSCRIPTION_CANCEL_REQUEST = 'SUBSCRIPTION_CANCEL_REQUEST';
export const SUBSCRIPTION_CANCEL_SUCCESS = 'SUBSCRIPTION_CANCEL_SUCCESS';
export const SUBSCRIPTION_CANCEL_FAILURE = 'SUBSCRIPTION_CANCEL_FAILURE';
export const SUBSCRIPTION_GET_REQUEST = 'SUBSCRIPTION_GET_REQUEST';
export const SUBSCRIPTION_GET_SUCCESS = 'SUBSCRIPTION_GET_SUCCESS';
export const SUBSCRIPTION_GET_FAILURE = 'SUBSCRIPTION_GET_FAILURE';
export const SUBSCRIPTION_RESUME_REQUEST = 'SUBSCRIPTION_RESUME_REQUEST';
export const SUBSCRIPTION_RESUME_SUCCESS = 'SUBSCRIPTION_RESUME_SUCCESS';
export const SUBSCRIPTION_RESUME_FAILURE = 'SUBSCRIPTION_RESUME_FAILURE';
export const SUBSCRIPTION_TOGGLE_INTERVAL = 'SUBSCRIPTION_TOGGLE_INTERVAL';
export const SUBSCRIPTION_LINK_REQUEST = 'SUBSCRIPTION_LINK_REQUEST';
export const SUBSCRIPTION_LINK_SUCCESS = 'SUBSCRIPTION_LINK_SUCCESS';
export const SUBSCRIPTION_LINK_FAILURE = 'SUBSCRIPTION_LINK_FAILURE';
export const SUBSCRIPTION_UNLINK_REQUEST = 'SUBSCRIPTION_UNLINK_REQUEST';
export const SUBSCRIPTION_UNLINK_SUCCESS = 'SUBSCRIPTION_UNLINK_SUCCESS';
export const SUBSCRIPTION_UNLINK_FAILURE = 'SUBSCRIPTION_UNLINK_FAILURE';
export const SUBSCRIPTION_DATAPOPUPCLOSED = 'SUBSCRIPTION_DATAPOPUPCLOSED';

export const STRIPE_INVOICE_REQUEST = 'STRIPE_INVOICE_REQUEST';
export const STRIPE_INVOICE_SUCCESS = 'STRIPE_INVOICE_SUCCESS';
export const STRIPE_INVOICE_FAILURE = 'STRIPE_INVOICE_FAILURE';

export const USER_UPDATE_SETTINGS_REQUEST = 'USER_UPDATE_SETTINGS_REQUEST';
export const USER_UPDATE_SETTINGS_SUCCESS = 'USER_UPDATE_SETTINGS_SUCCESS';
export const USER_UPDATE_SETTINGS_FAILURE = 'USER_UPDATE_SETTINGS_FAILURE';
export const USER_DELETE_ACCOUNT_SUCCESS = 'USER_DELETE_ACCOUNT_SUCCESS';
export const USER_CHANGE_PASSWORD_SUCCESS = 'USER_CHANGE_PASSWORD_SUCCESS';
export const USER_CHANGE_EMAIL_SUCCESS = 'USER_CHANGE_EMAIL_SUCCESS';
export const USER_UPDATE_EMAIL_PREFERENCE_SUCCESS = 'USER_UPDATE_EMAIL_PREFERENCE_SUCCESS';

export const CONTENT_DELETE_REQUEST = 'CONTENT_DELETE_REQUEST';
export const CONTENT_DELETE_SUCCESS = 'CONTENT_DELETE_SUCCESS';
export const CONTENT_DELETE_FAILURE = 'CONTENT_DELETE_FAILURE';

export const RUN_GET_REQUEST = 'RUN_GET_REQUEST';
export const RUN_GET_SUCCESS = 'RUN_GET_SUCCESS';
export const RUN_GET_FAILURE = 'RUN_GET_FAILURE';
export const RUN_CREATE_UPDATE_REQUEST = 'RUN_CREATE_UPDATE_REQUEST';
export const RUN_CREATE_UPDATE_SUCCESS = 'RUN_CREATE_UPDATE_SUCCESS';
export const RUN_CREATE_UPDATE_FAILURE = 'RUN_CREATE_UPDATE_FAILURE';
export const RUN_GET_ANALYTICS_REQUEST = 'RUN_GET_ANALYTICS_REQUEST';
export const RUN_GET_ANALYTICS_SUCCESS = 'RUN_GET_ANALYTICS_SUCCESS';
export const RUN_GET_ANALYTICS_FAILURE = 'RUN_GET_ANALYTICS_FAILURE';
export const RUN_UPDATE_PAUSED = 'RUN_UPDATE_PAUSED';
export const RUN_XAPI_STATEMENT_RECEIVED = 'RUN_XAPI_STATEMENT_RECEIVED';
export const RUN_ADD_USER = 'RUN_ADD_USER';
export const RUN_UPDATE_USER = 'RUN_UPDATE_USER';
export const RUN_ADD_ANSWER = 'RUN_ADD_ANSWER';

export const UI_RESET_ERRORS = 'UI_RESET_ERRORS';
export const UI_CHANGE_LANGUAGE = 'UI_CHANGE_LANGUAGE';
export const UI_SHOW_DIALOG = 'UI_SHOW_DIALOG';
export const UI_HIDE_DIALOG = 'UI_HIDE_DIALOG';
export const UI_NAVIGATE = 'UI_NAVIGATE';
export const UI_CLIPBOARD_CUT = 'UI_CLIPBOARD_CUT';

export const XAPI_STATEMENT_RECEIVED = 'XAPI_STATEMENT_RECEIVED';

export const FOLDERS_DELETEFOLDER_REQUEST = 'FOLDERS_DELETEFOLDER_REQUEST';
export const FOLDERS_DELETEFOLDER_SUCCESS = 'FOLDERS_DELETEFOLDER_SUCCESS';
export const FOLDERS_DELETEFOLDER_FAILURE = 'FOLDERS_DELETEFOLDER_FAILURE';
export const FOLDERS_DELETE_SUCCESS = 'FOLDERS_DELETE_SUCCESS';
export const FOLDERS_CUT_AND_PASTE_SUCCESS = 'FOLDERS_CUT_AND_PASTE_SUCCESS';

export const FOLDER_CREATE_REQUEST = 'FOLDER_CREATE_REQUEST';
export const FOLDER_CREATE_SUCCESS = 'FOLDER_CREATE_SUCCESS';
export const FOLDER_CREATE_FAILURE = 'FOLDER_CREATE_FAILURE';
export const FOLDER_UPDATE_SUCCESS = 'FOLDER_UPDATE_SUCCESS';

// interfaces

export interface IAuthLoginRequestAction {
  type: typeof AUTH_LOGIN_REQUEST;
  payload: {
    email: string;
  };
}

export interface IAuthGetSessionRequestAction {
  type: typeof AUTH_GETSESSION_REQUEST;
}

export interface IAuthGetSessionSuccessAction {
  type: typeof AUTH_GETSESSION_SUCCESS;
  payload: {
    user: IUser;
  };
}

export interface IAuthGetSessionFailureAction {
  type: typeof AUTH_GETSESSION_FAILURE;
  errorCode: string;
}

export interface IAuthLoginSuccessAction {
  type: typeof AUTH_LOGIN_SUCCESS;
  payload: {};
}

export interface IAutLogoutRequestAction {
  type: typeof AUTH_LOGOUT_REQUEST;
}

export interface IAuthRegisterRequestAction {
  type: typeof AUTH_REGISTER_REQUEST;
  payload: {
    email: string;
    username: string;
  };
}

export interface ISubscriptionCancelRequestAction {
  type: typeof SUBSCRIPTION_CANCEL_REQUEST;
}

export interface ISubscriptionCancelSuccessAction {
  type: typeof SUBSCRIPTION_CANCEL_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionCancelFailureAction {
  type: typeof SUBSCRIPTION_CANCEL_FAILURE;
  payload: Error;
}

export interface ISubscriptionResumeRequestAction {
  type: typeof SUBSCRIPTION_RESUME_REQUEST;
}

export interface ISubscriptionResumeSuccessAction {
  type: typeof SUBSCRIPTION_RESUME_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionResumeFailureAction {
  type: typeof SUBSCRIPTION_RESUME_FAILURE;
  payload: Error;
}

export interface ISubscriptionGetRequestAction {
  type: typeof SUBSCRIPTION_GET_REQUEST;
}

export interface ISubscriptionGetSuccessAction {
  type: typeof SUBSCRIPTION_GET_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionGetFailureAction {
  type: typeof SUBSCRIPTION_GET_FAILURE;
  payload: Error;
}

export interface ISubscriptionToggleIntervalAction {
  type: typeof SUBSCRIPTION_TOGGLE_INTERVAL;
}

export interface ISubscriptionLinkRequestAction {
  type: typeof SUBSCRIPTION_LINK_REQUEST;
  payload: {
    subscriptionId: string;
  };
}

export interface ISubscriptionLinkSuccessAction {
  type: typeof SUBSCRIPTION_LINK_SUCCESS;
  payload: {
    subscription: ISubscription;
  };
}

export interface ISubscriptionLinkFailureAction {
  type: typeof SUBSCRIPTION_LINK_FAILURE;
  errorCode: string;
}

export interface ISubscriptionUnlinkRequestAction {
  type: typeof SUBSCRIPTION_UNLINK_REQUEST;
  payload: {
    subscriptionId: string;
  };
}

export interface ISubscriptionUnlinkSuccessAction {
  type: typeof SUBSCRIPTION_UNLINK_SUCCESS;
}

export interface ISubscriptionUnlinkFailureAction {
  type: typeof SUBSCRIPTION_UNLINK_FAILURE;
  errorCode: string;
}

export interface ISubscriptionDataPopupClosedAction {
  type: typeof SUBSCRIPTION_DATAPOPUPCLOSED;
  payload: {
    id?: string;
    reference?: string;
  };
}

export interface IStripeInvoiceRequestAction {
  type: typeof STRIPE_INVOICE_REQUEST;
}

export interface IStripeInvoiceSuccessAction {
  type: typeof STRIPE_INVOICE_SUCCESS;
  payload: { invoiceUrl: string };
}

export interface IStripeInvoiceFailureAction {
  type: typeof STRIPE_INVOICE_FAILURE;
  payload: Error;
}

export interface IUserUpdateSettingsRequestAction {
  type: typeof USER_UPDATE_SETTINGS_REQUEST;
  payload: Partial<IUser>;
}

export interface IUserUpdateSettingsSuccessAction {
  type: typeof USER_UPDATE_SETTINGS_SUCCESS;
  payload: Partial<IUser>;
}

export interface IUserUpdateSettingsFailureAction {
  type: typeof USER_UPDATE_SETTINGS_FAILURE;
  payload: Error;
}

export interface IUserUpdateEmailPreferenceSuccessAction {
  type: typeof USER_UPDATE_EMAIL_PREFERENCE_SUCCESS;
  payload: { newsletter: boolean };
}

export interface IUserChangeEmailSuccessAction {
  type: typeof USER_CHANGE_EMAIL_SUCCESS;
  payload: { email: string };
}

export interface IUserChangePasswordSuccessAction {
  type: typeof USER_CHANGE_PASSWORD_SUCCESS;
}

export interface IUserDeleteAccountSuccessAction {
  type: typeof USER_DELETE_ACCOUNT_SUCCESS;
}

export interface IContentDeleteRequestAction {
  type: typeof CONTENT_DELETE_REQUEST;
  payload: {
    contentIds: string[];
  };
}

export interface IContentDeleteSuccessAction {
  type: typeof CONTENT_DELETE_SUCCESS;
  payload: {
    contentIds: string[];
  };
}

export interface IContentDeleteFailureAction {
  type: typeof CONTENT_DELETE_FAILURE;
  payload: {
    error: Error;
    originalContentItems: any[];
  };
}

export interface IUIResetErrorsAction {
  type: typeof UI_RESET_ERRORS;
}

export interface IUIChangeLanguageAction {
  type: typeof UI_CHANGE_LANGUAGE;
  payload: {
    language: string;
  };
}

export interface IUIShowDialogAction {
  type: typeof UI_SHOW_DIALOG;
  payload: {
    key: DialogKeys;
    context?: string;
  };
}

export interface IUIHideDialogAction {
  type: typeof UI_HIDE_DIALOG;
  payload: {
    key: DialogKeys;
  };
}

export interface IUINavigateAction {
  type: typeof UI_NAVIGATE;
  payload: {
    path: string;
  };
}

export interface IUIClipboardCutAction {
  type: typeof UI_CLIPBOARD_CUT;
  payload: {
    cutFromFolderId: string;
  };
}

export interface IFoldersDeleteFolderRequestAction {
  type: typeof FOLDERS_DELETEFOLDER_REQUEST;
  payload: {
    folderIds: string[];
  };
}

export interface IFoldersDeleteFolderSuccessAction {
  type: typeof FOLDERS_DELETEFOLDER_SUCCESS;
  payload: {
    folderIds: string[];
  };
}

export interface IFoldersDeleteFolderFailureAction {
  type: typeof FOLDERS_DELETEFOLDER_FAILURE;
  payload: Error;
}

export interface IFoldersDeleteSuccessAction {
  type: typeof FOLDERS_DELETE_SUCCESS;
  payload: {
    folderIds: string[];
  };
}

export interface IFoldersCutAndPasteSuccessAction {
  type: typeof FOLDERS_CUT_AND_PASTE_SUCCESS;
  payload: {
    cutFolderId: string;
    pasteFolderId: string;
    contentIds: string[];
  };
}

export interface IFolderCreateRequestAction {
  type: typeof FOLDER_CREATE_REQUEST;
  payload: {
    tempId: string;
    name: string;
    parent_id: string;
    workspace_id: string;
    color?: string;
  };
}

export interface IFolderCreateSuccessAction {
  type: typeof FOLDER_CREATE_SUCCESS;
  payload: {
    tempId: string;
    id: string;
    name: string;
    parent_id: string;
    workspace_id: string;
    color?: string;
  };
}

export interface IFolderCreateFailureAction {
  type: typeof FOLDER_CREATE_FAILURE;
  payload: {
    tempId: string;
    error: Error;
  };
}

export interface IFolderUpdateSuccessAction {
  type: typeof FOLDER_UPDATE_SUCCESS;
  payload: {
    id: string;
    name: string;
    color: string;
  };
}

export interface IRunGetRequestAction {
  type: typeof RUN_GET_REQUEST;
  payload: {
    runId: string;
  };
}

export interface IRunGetSuccessAction {
  type: typeof RUN_GET_SUCCESS;
  payload: {
    run: any;
  };
}

export interface IRunGetFailureAction {
  type: typeof RUN_GET_FAILURE;
  payload: Error;
}

export interface IRunCreateUpdateRequestAction {
  type: typeof RUN_CREATE_UPDATE_REQUEST;
  payload: {
    runId?: string;
    contentId?: string;
    input?: any;
  };
}

export interface IRunCreateUpdateSuccessAction {
  type: typeof RUN_CREATE_UPDATE_SUCCESS;
  payload: {
    run: any;
  };
}

export interface IRunCreateUpdateFailureAction {
  type: typeof RUN_CREATE_UPDATE_FAILURE;
  payload: Error;
}

export interface IRunGetAnalyticsRequestAction {
  type: typeof RUN_GET_ANALYTICS_REQUEST;
  payload: {
    runId: string;
  };
}

export interface IRunGetAnalyticsSuccessAction {
  type: typeof RUN_GET_ANALYTICS_SUCCESS;
  payload: {
    users: any[];
    answers: any[];
    interactions: any[];
    contentId: string;
  };
}

export interface IRunGetAnalyticsFailureAction {
  type: typeof RUN_GET_ANALYTICS_FAILURE;
  payload: Error;
}

export interface IRunUpdatePausedAction {
  type: typeof RUN_UPDATE_PAUSED;
  payload: {
    paused: boolean;
  };
}

export interface IRunXAPIStatementReceivedAction {
  type: typeof RUN_XAPI_STATEMENT_RECEIVED;
  payload: any;
}

export interface IRunAddUserAction {
  type: typeof RUN_ADD_USER;
  payload: {
    user: any;
  };
}

export interface IRunUpdateUserAction {
  type: typeof RUN_UPDATE_USER;
  payload: {
    userId: string;
    name: string;
  };
}

export interface IRunAddAnswerAction {
  type: typeof RUN_ADD_ANSWER;
  payload: any;
}

export type ActionTypes =
  | IAuthLoginRequestAction
  | IAuthLoginSuccessAction
  | IAuthRegisterRequestAction
  | IAutLogoutRequestAction
  | IAuthGetSessionRequestAction
  | IAuthGetSessionSuccessAction
  | IAuthGetSessionFailureAction
  | ISubscriptionCancelRequestAction
  | ISubscriptionCancelSuccessAction
  | ISubscriptionCancelFailureAction
  | ISubscriptionGetRequestAction
  | ISubscriptionGetSuccessAction
  | ISubscriptionGetFailureAction
  | ISubscriptionResumeRequestAction
  | ISubscriptionResumeSuccessAction
  | ISubscriptionResumeFailureAction
  | ISubscriptionToggleIntervalAction
  | ISubscriptionLinkRequestAction
  | ISubscriptionLinkSuccessAction
  | ISubscriptionLinkFailureAction
  | ISubscriptionUnlinkRequestAction
  | ISubscriptionUnlinkSuccessAction
  | ISubscriptionUnlinkFailureAction
  | ISubscriptionDataPopupClosedAction
  | IStripeInvoiceRequestAction
  | IStripeInvoiceSuccessAction
  | IStripeInvoiceFailureAction
  | IUserUpdateSettingsRequestAction
  | IUserUpdateSettingsSuccessAction
  | IUserUpdateSettingsFailureAction
  | IUserUpdateEmailPreferenceSuccessAction
  | IUserChangeEmailSuccessAction
  | IUserChangePasswordSuccessAction
  | IUserDeleteAccountSuccessAction
  | IContentDeleteRequestAction
  | IContentDeleteSuccessAction
  | IContentDeleteFailureAction
  | IUIResetErrorsAction
  | IUIChangeLanguageAction
  | IUIShowDialogAction
  | IUIHideDialogAction
  | IUINavigateAction
  | IUIClipboardCutAction
  | IFoldersDeleteFolderRequestAction
  | IFoldersDeleteFolderSuccessAction
  | IFoldersDeleteFolderFailureAction
  | IFoldersDeleteSuccessAction
  | IFoldersCutAndPasteSuccessAction
  | IFolderCreateRequestAction
  | IFolderCreateSuccessAction
  | IFolderCreateFailureAction
  | IFolderUpdateSuccessAction
  | IRunGetRequestAction
  | IRunGetSuccessAction
  | IRunGetFailureAction
  | IRunCreateUpdateRequestAction
  | IRunCreateUpdateSuccessAction
  | IRunCreateUpdateFailureAction
  | IRunGetAnalyticsRequestAction
  | IRunGetAnalyticsSuccessAction
  | IRunGetAnalyticsFailureAction
  | IRunUpdatePausedAction
  | IRunXAPIStatementReceivedAction
  | IRunAddUserAction
  | IRunUpdateUserAction
  | IRunAddAnswerAction
  | WorkspaceActionTypes
  | AppActionTypes
  | ContentBrowserActionTypes
  | H5PEditorActionTypes
  | CelloActionTypes;
